// <head> metadata for AboutPage (https://www.dbos.dev/about).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      name: 'description',
      content:
        'At DBOS, we’re radically rethinking the way software and AI agents are engineered and made fault tolerant. Learn more about our investors, team and career opportunities.',
    },
    {
      property: 'og:title',
      content: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      property: 'og:description',
      content:
        'At DBOS, we’re radically rethinking the way software and AI agents are engineered and made fault tolerant. Learn more about our investors, team and career opportunities.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS - Effortless Open Source Durable Workflow Orchestration',
    },
    {
      name: 'twitter:description',
      content:
        'At DBOS, we’re radically rethinking the way software and AI agents are engineered and made fault tolerant. Learn more about our investors, team and career opportunities.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/about',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
